import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'yesNo'
})
export class YesNoPipe implements PipeTransform {

  transform(val: string): any {
      if (val && val !== null  && typeof val !== 'string') {
          return val;
      }
      let value = (!val || val === null || val === '' || val.trim().length === 0) ? '' : val;
      if (value.trim().toUpperCase() === 'Y' || value.trim().toUpperCase() === 'YES') {
          value = 'Yes';
      } else if (value.trim().toUpperCase() === 'N' || value.trim().toUpperCase() === 'NO') {
          value = 'No';
      }

      return value;
  }

}
